import type { GuideCommand } from "@asurion-core/expert-workspace-timeline";
import type { ReactNode } from "react";

import { Flex } from "@mantine/core";
import { ErrorBoundary } from "react-error-boundary";

import { InlineGuidedFlowsPanel } from "@/components/workspace/GuidedFlowsPanel";
import { UI_ORCHESTRATION_COMPONENT } from "@/expert-hub/data/expertHubErrorMetric";
import { useLogger } from "@/sdk/logging/LoggerProvider";
import { trackedBoundaryProps } from "@/shared-utils";
import { PlatformTimeline } from "@/timeline";

/** What AI Assist needs to show the guide inline (`isAiAssistGuidedFlowEnabled`). */
export interface InlineGuide {
    title: string;
    onClose: () => void;
    /** Launches a guide from the Toolbox ("Launch guided flow" / `/g`). */
    toolboxCommand: GuideCommand;
}

export interface AssistTabProps {
    guide?: ReactNode;
    isGuideOpen?: boolean;
    /** Set to render the guide inline above the timeline; omitted, AI Assist shows no guide. */
    inlineGuide?: InlineGuide;
}

export function AssistTab({ guide, isGuideOpen, inlineGuide }: AssistTabProps) {
    const logger = useLogger({ module: "AssistTab" });

    return (
        <Flex pos="absolute" inset={0} direction="column">
            {inlineGuide && isGuideOpen && guide ? (
                <InlineGuidedFlowsPanel guide={guide} title={inlineGuide.title} onClose={inlineGuide.onClose} />
            ) : null}
            <ErrorBoundary {...trackedBoundaryProps(logger, UI_ORCHESTRATION_COMPONENT)}>
                <PlatformTimeline guide={inlineGuide?.toolboxCommand} />
            </ErrorBoundary>
        </Flex>
    );
}
